import { render } from "./ListeMonnaiesDisponiblesPage.vue?vue&type=template&id=926b6cd2&ts=true"
import script from "./ListeMonnaiesDisponiblesPage.vue?vue&type=script&lang=ts"
export * from "./ListeMonnaiesDisponiblesPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__